import React, { Component, useEffect } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as managerApplicantActions from "../../redux/actions/managerApplicantAction";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import ErsApplicantComponent from "../../components/ErsApplicant";
import { initialPagination, ersInitialPagination } from "../../App.config";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const ErsApplicant = (props, context) => {
  const stdReducer = useSelector((state) => state.stdReducer);
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  const managerApplicantReducer = useSelector(
    (state) => state.managerApplicantReducer
  );

  const dispatch = useDispatch();
  let stdAction = bindActionCreators(stdActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const managerApplicantAction = bindActionCreators(
    managerApplicantActions,
    dispatch
  );
  const attachmentsAction = bindActionCreators(attachmentsActions, dispatch);

  ///Set initial pagination and call api after first render
  useEffect(() => {
    if (profileReducer.managersDetails.companyId) {
      attachmentsAction.setCurrentPage(initialPagination.pageNo);
      attachmentsAction.setPageSize(initialPagination.pageSize);
      managerApplicantAction.getEmployeebyManager(ersInitialPagination, null, profileReducer);
      return () => {
        managerApplicantAction.setCurrentPage(ersInitialPagination.pageNo);
        managerApplicantAction.setPageSize(ersInitialPagination.pageSize);
      };
    }
  }, [profileReducer.managersDetails.companyId]);

  const searchByName = (name) => {
    managerApplicantAction.getEmployeebyManager(ersInitialPagination, name, profileReducer);
    managerApplicantAction.setCurrentPage(ersInitialPagination.pageNo);
    managerApplicantAction.setPageSize(ersInitialPagination.pageSize);
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const setFilteredApplicants = (filteredApplicants) => {
    managerApplicantAction.setFilteredApplicants(filteredApplicants);
  };

  const onChange = (page) => {
    managerApplicantAction.setCurrentPage(page.value);
    managerApplicantAction.getEmployeebyManager(
      {
        pageNo: page.value,
        pageSize: managerApplicantReducer.pageSize,
        totalRows: managerApplicantReducer.totalRows,
      },
      page.searchKey,
      profileReducer
    );
  };

  // const onPageSizeChange = (pageSize) => {
  //   managerApplicantAction.getEmployeebyManager(
  //     {
  //       pageNo: ersInitialPagination.pageNo,
  //       pageSize: pageSize,
  //       totalRows: managerApplicantReducer.totalRows,
  //     },
  //     null
  //   );
  //   managerApplicantAction.setCurrentPage(ersInitialPagination.pageNo);
  //   managerApplicantAction.setPageSize(pageSize);
  // };

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <ShowForPermission module={PERMISSON_MODULES.SEARCH_BY_EMPLOYEE} permission={PERMISSION_TYPE.VIEW}>
          <ErsApplicantComponent
            context={context}
            setFilteredApplicants={setFilteredApplicants}
            applicants={managerApplicantReducer.applicants}
            filteredApplicants={managerApplicantReducer.filteredApplicants}
            currentPage={managerApplicantReducer.currentPage}
            pageSize={managerApplicantReducer.pageSize}
            totalRows={managerApplicantReducer.totalRows}
            searchByName={searchByName}
            openSetModal={openSetModal}
            closeRemoveModal={closeRemoveModal}
            // onPageSizeChange={onPageSizeChange}
            onChange={(props) => {
              onChange(props);
            }}
          />
        </ShowForPermission>
      </div>
    </>
  );
};

ErsApplicant.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default ErsApplicant;
